// extracted by mini-css-extract-plugin
export var grid = "related-products-module--grid--d8f76";
export var gridItem = "related-products-module--gridItem--dc687";
export var label = "related-products-module--label--638a2";
export var relatedProducts = "related-products-module--relatedProducts--0f951";
export var solo = "related-products-module--solo--5eff1";